import { register } from '../component.js';
import 'react';

var _socialIcons_patreon = register("patreon", {"color":"#000000","path":"M0,0H64V64H0ZM 52.8531 23.4586 C 52.8449 17.7383 48.3906 13.0488 43.1625 11.359 C 36.6711 9.259 28.1098 9.5625 21.9109 12.4855 C 14.3996 16.032 12.0398 23.7977 11.9523 31.5414 C 11.8812 37.9098 12.5156 54.6797 21.9738 54.8 C 29.0039 54.8875 30.0512 45.8312 33.3023 41.4699 c 2.3133 -3.1035 5.2937 -3.9785 8.9605 -4.8863 c 6.3027 -1.5613 10.5984 -6.5352 10.5902 -13.125 z m 0 0"});

export { _socialIcons_patreon as default };
